import React from 'react';
import CustomDatasetActionDropdownItem from './CustomDatasetActionDropdownItem';

const CustomDatasetActionDropdownItems = ({ actions }) => (
  actions.map((action) => (
    <CustomDatasetActionDropdownItem
      key={`custom_dataset_action_dropdown_item_${action.url}`}
      url={action.url}
      label={action.label}
      description={action.description}
      target={action.target}
      disabled={action.decode_errors.length > 0}
    />
  ))
);

export default CustomDatasetActionDropdownItems;
